export default (path: string) => {
  // Remove trailing slashes
  if (path.endsWith("/")) {
    path = path.slice(0, -1);
  }

  return path;
};
